(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer-menu"] && !Shopify.designMode) return;
  try {
    /**
   * Mobile Header Drawer Menu Controller
   *
   * Handles multi-level navigation with slide-in transitions
   * - Manages panel visibility and transitions
   * - Syncs with main drawer open/close state
   * - Prevents body scroll when drawer is open
   * - Resets to main menu when drawer closes
   */
  class HeaderDrawerMenu extends HTMLElement {
    constructor() {
      super();

      // State
      this.currentLevel = 'main';
      this.activeSubmenuIndex = null;

      // Elements
      this.mainPanel = this.querySelector('[data-menu-level="main"]');
      this.submenuPanels = this.querySelectorAll('[data-menu-level="submenu"]');
      this.submenuTriggers = this.querySelectorAll('[data-submenu-trigger]');
      this.backButtons = this.querySelectorAll('[data-submenu-back]');

      this.init();
    }

    init() {
      // Bind submenu triggers
      this.submenuTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => this.openSubmenu(e));
      });

      // Bind back buttons
      this.backButtons.forEach((button) => {
        button.addEventListener('click', (e) => this.closeSubmenu(e));
      });

      // Watch for drawer closing to reset menu
      // Use MutationObserver since events.js doesn't dispatch custom events
      const drawerComponent = this.closest('header-drawer-component');
      if (drawerComponent) {
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.attributeName === 'aria-hidden') {
              const isHidden = drawerComponent.getAttribute('aria-hidden') === 'true';
              if (isHidden) {
                this.resetMenu();
              }
            }
          });
        });

        observer.observe(drawerComponent, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
        });
      }
    }

    /**
     * Opens a submenu panel with slide-in animation
     */
    openSubmenu(event) {
      const trigger = event.currentTarget;
      const submenuIndex = trigger.dataset.submenuTrigger;
      const submenuPanel = this.querySelector(`#submenu-${submenuIndex}`);

      if (!submenuPanel) return;

      // Update state
      this.currentLevel = 'submenu';
      this.activeSubmenuIndex = submenuIndex;

      // Update ARIA
      trigger.setAttribute('aria-expanded', 'true');
      submenuPanel.setAttribute('aria-hidden', 'false');

      // Animate: slide main panel left, slide submenu in from right
      this.mainPanel.classList.remove('translate-x-0');
      this.mainPanel.classList.add('-translate-x-full');

      submenuPanel.classList.remove('translate-x-full');
      submenuPanel.classList.add('translate-x-0');

      // Announce to screen readers
      this.announceNavigation(`Viewing ${trigger.textContent.trim()} menu`);
    }

    /**
     * Closes active submenu and returns to main menu
     */
    closeSubmenu(event) {
      const button = event.currentTarget;
      const submenuIndex = button.dataset.submenuBack;
      const submenuPanel = this.querySelector(`#submenu-${submenuIndex}`);
      const trigger = this.querySelector(`[data-submenu-trigger="${submenuIndex}"]`);

      if (!submenuPanel) return;

      // Update state
      this.currentLevel = 'main';
      this.activeSubmenuIndex = null;

      // Update ARIA
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      submenuPanel.setAttribute('aria-hidden', 'true');

      // Animate: slide submenu right, slide main panel back to center
      submenuPanel.classList.remove('translate-x-0');
      submenuPanel.classList.add('translate-x-full');

      this.mainPanel.classList.remove('-translate-x-full');
      this.mainPanel.classList.add('translate-x-0');

      // Announce to screen readers
      this.announceNavigation('Back to main menu');
    }

    /**
     * Resets menu to initial state (called when drawer closes)
     */
    resetMenu() {
      // Return to main panel immediately (no animation since drawer is closed)
      if (this.currentLevel === 'submenu') {
        // Reset all panels
        this.mainPanel.classList.remove('-translate-x-full');
        this.mainPanel.classList.add('translate-x-0');

        this.submenuPanels.forEach((panel) => {
          panel.classList.remove('translate-x-0');
          panel.classList.add('translate-x-full');
          panel.setAttribute('aria-hidden', 'true');
        });

        // Reset triggers
        this.submenuTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
        });

        // Reset state
        this.currentLevel = 'main';
        this.activeSubmenuIndex = null;
      }

      // Scroll main panel back to top
      const mainPanelScroller = this.mainPanel.querySelector('.overflow-y-auto');
      if (mainPanelScroller) {
        mainPanelScroller.scrollTop = 0;
      }
    }

    /**
     * Announces navigation changes to screen readers
     */
    announceNavigation(message) {
      const announcement = document.createElement('div');
      announcement.setAttribute('role', 'status');
      announcement.setAttribute('aria-live', 'polite');
      announcement.className = 'sr-only';
      announcement.textContent = message;

      this.appendChild(announcement);

      // Remove after announcement
      setTimeout(() => {
        announcement.remove();
      }, 1000);
    }
  }

  // Register custom element
  if (!customElements.get('header-drawer-menu')) {
    customElements.define('header-drawer-menu', HeaderDrawerMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const megaMenus = document.querySelectorAll('.header-menu-item');

    megaMenus.forEach((menu) => {
      let closeTimer = null;
      const megaMenuDropdown = menu.nextElementSibling;

      // Function to open menu
      const openMenu = () => {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        menu.setAttribute('open', '');
      };

      // Function to close menu with delay
      const closeMenu = () => {
        closeTimer = setTimeout(() => {
          menu.removeAttribute('open');
        }, 100); // Small delay to prevent flickering
      };

      // Menu item hover events
      menu.addEventListener('mouseenter', openMenu);
      menu.addEventListener('mouseleave', closeMenu);

      // Dropdown hover events (if dropdown exists)
      if (megaMenuDropdown && megaMenuDropdown.classList.contains('mega-menu')) {
        megaMenuDropdown.addEventListener('mouseenter', openMenu);
        megaMenuDropdown.addEventListener('mouseleave', closeMenu);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sorting"] && !Shopify.designMode) return;
  try {
    // Desktop Sorting Component
  class SortingComponent extends HTMLElement {
    connectedCallback() {
      this.setupSortingListeners();
      this.setupClickOutsideToClose();
    }

    setupSortingListeners() {
      const radioInputs = this.querySelectorAll('input[type="radio"]');

      radioInputs.forEach((input) => {
        input.addEventListener('change', (event) => {
          if (event.target.checked) {
            // Close any parent dropdown/details element
            const parentDetails = this.closest('details');
            if (parentDetails) {
              parentDetails.open = false;
            }

            // Auto-submit form after short delay for better UX
            setTimeout(() => {
              const form = this.closest('form');
              if (form) {
                form.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }, 150);
          }
        });

        // Handle keyboard navigation
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    setupClickOutsideToClose() {
      // Remove existing listener to avoid duplicates
      if (this._clickOutsideHandler) {
        document.removeEventListener('click', this._clickOutsideHandler);
      }

      // Create and store the handler function
      this._clickOutsideHandler = (event) => {
        // Find the parent details element (sorting dropdown)
        const parentDetails = this.closest('details');
        
        if (!parentDetails || !parentDetails.open) return;

        // Check if the click is outside the dropdown
        if (!parentDetails.contains(event.target)) {
          parentDetails.open = false;
        }
      };

      // Add the event listener to document
      document.addEventListener('click', this._clickOutsideHandler);
    }

    disconnectedCallback() {
      // Clean up event listener when component is removed
      if (this._clickOutsideHandler) {
        document.removeEventListener('click', this._clickOutsideHandler);
      }
    }
  }

  // Mobile Sorting Component
  class SortingMobileComponent extends HTMLElement {
    connectedCallback() {
      this.setupSortingListeners();
    }

    setupSortingListeners() {
      const radioInputs = this.querySelectorAll('input[type="radio"]');
      const details = this.querySelector('details');
      const summary = this.querySelector('summary');

      radioInputs.forEach((input) => {
        input.addEventListener('change', (event) => {
          if (event.target.checked) {
            // Update summary text to show selected option
            this.updateSummaryText(event.target);

            // Close dropdown
            if (details) {
              details.open = false;
            }

            // Auto-submit form after short delay for better UX
            setTimeout(() => {
              const form = this.closest('form');
              if (form) {
                form.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }, 150);
          }
        });

        // Handle keyboard navigation
        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    }

    updateSummaryText(selectedInput) {
      const summary = this.querySelector('summary span');
      const selectedLabel = selectedInput.nextElementSibling;

      if (summary && selectedLabel) {
        // Extract the sort by text from the existing summary
        const currentText = summary.textContent;
        const sortByText = currentText.split(':')[0];
        summary.textContent = `${sortByText}: ${selectedLabel.textContent}`;
      }
    }
  }

  // Register the components
  document.addEventListener('DOMContentLoaded', () => {
    if (!customElements.get('sorting-component')) {
      customElements.define('sorting-component', SortingComponent);
    }
    if (!customElements.get('sorting-mobile-component')) {
      customElements.define('sorting-mobile-component', SortingMobileComponent);
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["title"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const scrollGradientElements = document.querySelectorAll('[data-scroll-gradient]');
    if (scrollGradientElements.length === 0) return;

    function updateScrollProgress() {
      // Use a fixed scroll range for consistent, responsive gradient changes
      const scrollRange = 800; // pixels
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Calculate progress with continuous cycling (0-100% repeating)
      const scrollProgress = ((scrollTop % scrollRange) / scrollRange) * 100;

      // Update all scroll gradient elements
      scrollGradientElements.forEach(function (element) {
        element.style.setProperty('--scroll-progress', scrollProgress + '%');
      });
    }

    // Update on scroll
    window.addEventListener('scroll', updateScrollProgress);

    // Initial update
    updateScrollProgress();
  });
  } catch(e) { console.error(e); }
})();

})();
